import { type FC } from 'react';

import { Link } from '@/packages/shared-ui';
import { preventDefault } from '@/packages/utils/event';

import { useCardOfferDataContext } from '../../../context/selectors';
import { Title } from '../components/Title';

export const TitleContainer: FC = () => {
  const { title, url } = useCardOfferDataContext();

  return (
    <Link behaviour="hover_black_to_primary" href={url} onClick={preventDefault}>
      <Title text={title} />
    </Link>
  );
};
